import { Component, OnInit } from '@angular/core';


interface LogType {
  id: string;
  name: string;
}

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {

  constructor() { }

  logTypes: LogType[] = [
    { id: 'sales', name: 'SALES'},
    { id: 'beneficiaries', name: 'BENEFICIARIES'},
    { id: 'users', name: 'USERS'},
    // Agrega más tipos aquí
    // { id: 'users', name: 'Usuarios', icon: 'people' },
    // { id: 'system', name: 'Sistema', icon: 'settings' }
  ];

  selectedLog: string = '';

  ngOnInit(): void {
    // Selecciona el primer tipo de log por defecto si existe
    if (this.logTypes.length > 0) {
      this.selectedLog = this.logTypes[0].id;
    }
  }

  selectLog(logId: string): void {
    this.selectedLog = logId;
  }

}
